export const parseAddress = (address: string) => {
  const [street, cityStateZip = ""] = address.split(/,(.+)/); // Split the address at the first comma

  return {
    street: street.trim(),
    cityStateZip: cityStateZip.trim(),
  };
};
